/* eslint-disable max-len */
/* eslint-disable prettier/prettier */

/**
 * This file can be used for unit tests.
 */
import {
  RewardListDto,
  RewardReasonType,
} from '@peartherapeutics/hylia-api-client';

export const rewardListInitialState: RewardListDto = {
  inAppCm: true,
  earnedRewardsCount: 9,
  sumEarnedRewards: '$95',
  earnedRewards: [
    {
      amount: '$50',
      amountValue: 50,
      date: '2022-10-07T04:00:00.000Z',
      type: RewardReasonType.UserGuideCompletion,
    },
    {
      amount: '$20',
      amountValue: 20,
      date: '2022-10-04T04:00:00.000Z',
      type: RewardReasonType.NegativeScreen,
    },
    {
      amount: '$10',
      amountValue: 10,
      date: '2022-10-01T04:00:00.000Z',
      type: RewardReasonType.LessonCompletion,
    },
    {
      amount: '$5',
      amountValue: 5,
      date: '2022-09-28T04:00:00.000Z',
      type: RewardReasonType.UserGuideCompletion,
    },
    {
      amount: '$4',
      amountValue: 4,
      date: '2022-09-25T04:00:00.000Z',
      type: RewardReasonType.NegativeScreen,
    },
    {
      amount: '$3',
      amountValue: 3,
      date: '2022-09-22T04:00:00.000Z',
      type: RewardReasonType.LessonCompletion,
    },
    {
      amount: '$2',
      amountValue: 2,
      date: '2022-09-19T04:00:00.000Z',
      type: RewardReasonType.UserGuideCompletion,
    },
    {
      amount: '$1',
      amountValue: 1,
      date: '2022-09-15T04:00:00.000Z',
      type: RewardReasonType.NegativeScreen,
    },
    {
      amount: '$0',
      amountValue: 0,
      date: '2022-09-12T04:00:00.000Z',
      type: RewardReasonType.LessonCompletion,
    },
  ],
};
